// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --kr-mobile-width: 960px;
  --kr-tablet-width: 1200px;
  --ui-grid-breakpoint: 768px;
  --kr-max-content-width: 1156px;
}

.kb-labfront.container .municipality-map {
  position: relative;
  overflow: visible;
  max-width: 500px;
}
.kb-labfront.container .municipality-map figure.muni-map-layers {
  width: 100% !important;
  aspect-ratio: 1/1.25101 !important;
  position: relative !important;
  overflow: visible !important;
}
.kb-labfront.container .municipality-map figure.muni-map-layers .muni-map-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
.kb-labfront.container .municipality-map figure.muni-map-layers .muni-map-layer svg {
  display: block;
}
.kb-labfront.container .municipality-map figure.muni-map-layers .muni-map-layer.basemap {
  opacity: 0.15;
}
.kb-labfront.container .municipality-map figure.muni-map-layers .muni-map-layer.polygon svg path {
  fill: #c7cd04;
  stroke: #c7cd04;
}
.kb-labfront.container .municipality-map figure.muni-map-layers .muni-map-layer.outline {
  width: 45%;
  height: 45%;
  top: auto;
  right: 0;
  bottom: 10%;
  left: auto;
  margin: 0 0 0 0;
}
.kb-labfront.container .municipality-map figure.muni-map-layers .muni-map-layer.outline svg {
  display: block;
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
}
.kb-labfront.container .municipality-map figure.muni-map-layers .muni-map-layer.outline svg .totalareal {
  fill: rgb(0, 68.0510204082, 123.5);
  stroke: rgb(0, 68.0510204082, 123.5);
  stroke-width: 1;
}
.kb-labfront.container .municipality-map figure.muni-map-layers .muni-map-layer.outline svg .landareal {
  fill: #c7cd04;
  stroke: #c7cd04;
}
.kb-labfront.container .municipality-map figure.muni-map-layers .muni-map-layer.blipper {
  width: auto;
  display: none;
  margin: 0 0 0 0;
  padding: 0 0 0 0;
}
.kb-labfront.container .municipality-map figure.muni-map-layers .muni-map-layer.blipper svg .ring1, .kb-labfront.container .municipality-map figure.muni-map-layers .muni-map-layer.blipper svg .ring2, .kb-labfront.container .municipality-map figure.muni-map-layers .muni-map-layer.blipper svg .ring3, .kb-labfront.container .municipality-map figure.muni-map-layers .muni-map-layer.blipper svg .ring4 {
  fill: none;
  stroke: #c7cd04;
  stroke-miterlimit: 10;
  transform-origin: center center;
}
.kb-labfront.container .municipality-map figure.muni-map-layers .muni-map-layer.blipper.blip {
  display: block;
}
.kb-labfront.container .municipality-map figure.muni-map-layers .muni-map-layer.blipper.blip svg .ring1 {
  filter: blur(1px);
  animation: blipper-animation-ring1 3s linear infinite;
}
.kb-labfront.container .municipality-map figure.muni-map-layers .muni-map-layer.blipper.blip svg .ring2 {
  filter: blur(2px);
  animation: blipper-animation-ring2 3s linear infinite;
}
.kb-labfront.container .municipality-map figure.muni-map-layers .muni-map-layer.blipper.blip svg .ring3 {
  filter: blur(3px);
  animation: blipper-animation-ring3 3s linear infinite;
}
.kb-labfront.container .municipality-map figure.muni-map-layers .muni-map-layer.blipper.blip svg .ring4 {
  filter: blur(4px);
  animation: blipper-animation-ring4 3s linear infinite;
}

@keyframes blipper-animation-ring1 {
  0% {
    stroke: rgba(199, 205, 4, 0);
    scale: 0;
  }
  1% {
    stroke: #c7cd04;
  }
  5% {
    stroke: #c7cd04;
  }
  90% {
    stroke: rgba(199, 205, 4, 0);
  }
  100% {
    stroke: rgba(199, 205, 4, 0);
    scale: 2.5;
  }
}
@keyframes blipper-animation-ring2 {
  0% {
    stroke: rgba(199, 205, 4, 0);
    scale: 0.2;
  }
  10% {
    stroke: rgba(199, 205, 4, 0.9);
  }
  15% {
    stroke: rgba(199, 205, 4, 0.9);
  }
  70% {
    stroke: rgba(199, 205, 4, 0);
  }
  100% {
    stroke: rgba(199, 205, 4, 0);
    scale: 1.8;
  }
}
@keyframes blipper-animation-ring3 {
  0% {
    stroke: rgba(199, 205, 4, 0);
    scale: 0.3;
  }
  20% {
    stroke: rgba(199, 205, 4, 0.8);
  }
  25% {
    stroke: rgba(199, 205, 4, 0.8);
  }
  80% {
    stroke: rgba(199, 205, 4, 0);
  }
  100% {
    stroke: rgba(199, 205, 4, 0);
    scale: 1.4;
  }
}
@keyframes blipper-animation-ring4 {
  0% {
    stroke: rgba(199, 205, 4, 0);
    scale: 0.4;
  }
  30% {
    stroke: rgba(199, 205, 4, 0.7);
  }
  35% {
    stroke: rgba(199, 205, 4, 0.7);
  }
  90% {
    stroke: rgba(199, 205, 4, 0);
  }
  100% {
    stroke: rgba(199, 205, 4, 0);
    scale: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/styling/_kr.scss","webpack://./src/components/pageElements/MunicipalityMap/MunicipalityMap.scss","webpack://./src/styling/_kr_colors.scss"],"names":[],"mappings":"AAiBA;EACE,wBAAA;EACA,yBAAA;EACA,2BAAA;EACA,8BAAA;AChBF;;AAFE;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;AAKJ;AAHM;EACE,sBAAA;EACA,kCAAA;EACA,6BAAA;EACA,4BAAA;AAKR;AAJQ;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;AAMV;AALU;EACE,cAAA;AAOZ;AALU;EACE,aAAA;AAOZ;AALU;EACE,aCbJ;EDcI,eCdJ;ADqBR;AALU;EACE,UAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;AAOZ;AAHY;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AAKd;AAJc;EACE,kCAAA;EACA,oCAAA;EACA,eAAA;AAMhB;AAJc;EACE,aCvCR;EDwCQ,eCxCR;AD8CR;AAFU;EACE,WAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AAIZ;AAFc;EACE,UAAA;EACA,eCpDR;EDqDQ,qBAAA;EACA,+BAAA;AAIhB;AADY;EACE,cAAA;AAGd;AADgB;EAAS,iBAAA;EAAqB,qDAAA;AAK9C;AAJgB;EAAS,iBAAA;EAAqB,qDAAA;AAQ9C;AAPgB;EAAS,iBAAA;EAAqB,qDAAA;AAW9C;AAVgB;EAAS,iBAAA;EAAqB,qDAAA;AAc9C;;AAJA;EACI;IAAK,4BAAA;IAAgC,QAAA;EASvC;EARE;IAAK,eAAA;EAWP;EAVE;IAAK,eAAA;EAaP;EAZC;IAAM,4BAAA;EAeP;EAdA;IAAO,4BAAA;IAAgC,UAAA;EAkBvC;AACF;AAjBA;EACI;IAAK,4BAAA;IAAgC,UAAA;EAqBvC;EApBC;IAAM,8BAAA;EAuBP;EAtBC;IAAM,8BAAA;EAyBP;EAxBC;IAAM,4BAAA;EA2BP;EA1BA;IAAO,4BAAA;IAAgC,UAAA;EA8BvC;AACF;AA7BA;EACI;IAAK,4BAAA;IAAgC,UAAA;EAiCvC;EAhCC;IAAM,8BAAA;EAmCP;EAlCC;IAAM,8BAAA;EAqCP;EApCC;IAAM,4BAAA;EAuCP;EAtCA;IAAO,4BAAA;IAAgC,UAAA;EA0CvC;AACF;AAzCA;EACI;IAAK,4BAAA;IAAgC,UAAA;EA6CvC;EA5CC;IAAM,8BAAA;EA+CP;EA9CC;IAAM,8BAAA;EAiDP;EAhDC;IAAM,4BAAA;EAmDP;EAlDA;IAAO,4BAAA;IAAgC,QAAA;EAsDvC;AACF","sourcesContent":["@forward 'kr_colors';\n@forward 'semantic_ui_overrides';\n@forward 'labrador_overrides';\n\n// Maximum page size\n$max_content_width: 1156px;\n\n// Minimum left/right padding\n$min_content_gutter: 22px;\n\n// Minimum left/right padding\n$ui-grid-breakpoint: 768px;\n\n// Breakpoints\n$mobile_width: 960px;\n$tablet_width: $max_content_width + ( 2 * $min_content_gutter ); // 1200 px\n\n:root {\n  --kr-mobile-width: #{$mobile-width};\n  --kr-tablet-width: #{$tablet-width};\n  --ui-grid-breakpoint: #{$ui-grid-breakpoint};\n  --kr-max-content-width: #{$max_content_width};\n}\n\n@mixin max-page-dim {\n  position: relative;\n  max-width: $max_content_width;\n  margin: 0 auto;\n  @media ( max-width: $tablet-width ) {\n    padding-left: $min_content_gutter;\n    padding-right: $min_content_gutter;\n    &.no-gutter {\n      padding-left: 0;\n      padding-right: 0;\n      @media ( min-width: 748px ) and ( max-width: ( $max_content_width + ( $min_content_gutter * 2 ) ) ) {\n        padding-left: $min_content_gutter;\n        padding-right: $min_content_gutter;\n      }\n    }\n  }\n}","@use '/src/styling/kr';\n\n.kb-labfront.container {\n  .municipality-map {\n    position: relative;\n    overflow: visible;\n    max-width: 500px;\n    figure {\n      &.muni-map-layers {\n        width: 100.000% !important;\n        aspect-ratio: 1 / 1.25101 !important;\n        position: relative !important;\n        overflow: visible !important;\n        .muni-map-layer {\n          position: absolute;\n          top: 0;\n          left: 0;\n          width: 100%;\n          svg {\n            display: block;\n          }\n          &.basemap {\n            opacity: 0.15;\n          }\n          &.polygon svg path {\n            fill: kr.$green;\n            stroke: kr.$green;\n          }\n          &.outline {\n            width: 45%;\n            height: 45%;\n            top: auto;\n            right: 0;\n            bottom: 10%;\n            left: auto;\n            margin: 0 0 0 0;\n            @media ( max-width: 480px ) {\n\n            }\n            svg {\n              display: block;\n              width: 100%;\n              height: 100%;\n              display: block;\n              object-fit: contain; \n              .totalareal {\n                fill: lighten( kr.$blue, 5% );\n                stroke: lighten( kr.$blue, 5% );\n                stroke-width: 1;\n              }\n              .landareal {\n                fill: kr.$green;\n                stroke: kr.$green;\n              }\n            }\n          }\n          &.blipper {\n            width: auto;\n            display: none;\n            margin: 0 0 0 0;\n            padding: 0 0 0 0;\n            svg {\n              .ring1, .ring2, .ring3, .ring4 {\n                fill: none;\n                stroke: kr.$green;\n                stroke-miterlimit: 10;\n                transform-origin: center center;\n              }\n            }\n            &.blip {\n              display: block;\n              svg {\n                .ring1 { filter: blur( 1px ); animation: blipper-animation-ring1 3s linear infinite };\n                .ring2 { filter: blur( 2px ); animation: blipper-animation-ring2 3s linear infinite };\n                .ring3 { filter: blur( 3px ); animation: blipper-animation-ring3 3s linear infinite };\n                .ring4 { filter: blur( 4px ); animation: blipper-animation-ring4 3s linear infinite };\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@keyframes blipper-animation-ring1 {\n    0% { stroke: rgba( kr.$green, 0.0 ); scale: 0; }\n    1% { stroke: rgba( kr.$green, 1.0 ) }\n    5% { stroke: rgba( kr.$green, 1.0 ) }\n   90% { stroke: rgba( kr.$green, 0.0 ) }\n  100% { stroke: rgba( kr.$green, 0.0 ); scale: 2.5; }\n}\n@keyframes blipper-animation-ring2 {\n    0% { stroke: rgba( kr.$green, 0.0 ); scale: 0.2; }\n   10% { stroke: rgba( kr.$green, 0.9 ) }\n   15% { stroke: rgba( kr.$green, 0.9 ) }\n   70% { stroke: rgba( kr.$green, 0.0 ) }\n  100% { stroke: rgba( kr.$green, 0.0 ); scale: 1.8; }\n}\n@keyframes blipper-animation-ring3 {\n    0% { stroke: rgba( kr.$green, 0.0 ); scale: 0.3; }\n   20% { stroke: rgba( kr.$green, 0.8 ) }\n   25% { stroke: rgba( kr.$green, 0.8 ) }\n   80% { stroke: rgba( kr.$green, 0.0 ) }\n  100% { stroke: rgba( kr.$green, 0.0 ); scale: 1.4; }\n}\n@keyframes blipper-animation-ring4 {\n    0% { stroke: rgba( kr.$green, 0.0 ); scale: 0.4; }\n   30% { stroke: rgba( kr.$green, 0.7 ) }\n   35% { stroke: rgba( kr.$green, 0.7 ) }\n   90% { stroke: rgba( kr.$green, 0.0 ) }\n  100% { stroke: rgba( kr.$green, 0.0 ); scale: 1.0; }\n}\n","$black: #000000;\n$white: #ffffff;\n$semi-transparent-white: #ffffff22;\n\n$blue: #003662;\n$blue-light: #285274;\n$blue-bright: #e7f5ff;\n$blue-links: #0296ff;\n\n$red: #e52330;\n$red-dark: #940e19;\n\n$green: #c7cd04;\n$green-dark: #9D9f20;\n$green-light: #edf6ea;\n\n$purple-light: #f8f1fa;\n\n$orange-dark: #ff6600;\n$orange-light: #fff4e7;\n\n$tint-editorial: $blue-bright;\n$tint-opinions: $green-light;\n$tint-misc: $purple-light;\n$tint-advertorial: $orange-light;\n\n$link-color: var(--bodytext-link-color);\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
